export const DELETED_PAGE = 'DELETED_PAGE';

export const ROW_DETAIL = 'ROW_DETAIL';

export const UPDATE_SEARCH_STATE = 'UPDATE_SEARCH_STATE';
